<template>
  <v-btn
    color="primary"
    outlined
    :loading="loading"
    @click="download()"
  >
    <v-icon>
      mdi-download
    </v-icon>
    Baixar atual
  </v-btn>
</template>

<script>
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import DownloadMixin from '@/app/arch/mixins/DownloadMixin';
import LegalAgreementsRequest from '../LegalAgreementsRequest';

export default {
  name: 'LegalAgreementsLatestDownloadBtn',
  mixins: [ServiceMixin, DownloadMixin],
  data: () => ({
    requestClass: LegalAgreementsRequest,
    loading: false,
    dialogMessage: 'Essa ação irá baixar o documento mais recente',
    type: '',
  }),
  computed: {
    proxyRequest() {
      if (this.isType('NewSgvOnboardingContract')) {
        return () => this.requestClass.downloadLatestContract();
      }
      if (this.isType('TermsOfUse')) {
        return () => this.requestClass.downloadLatestTermsOfUse();
      }
      if (this.isType('PrivacyPolicy')) {
        return () => this.requestClass.downloadLatestPrivacyPolicy();
      }
      return () => Promise.resolve({});
    },
    isType() {
      return (type) => this.type === type;
    },
  },
  methods: {
    download() {
      this.confirmDownload(
        this.makeDownloadRequest,
        {
          text: this.dialogMessage,
        },
      );
    },
    makeDownloadRequest() {
      this.handleLoading();
      this.callService(
        this.proxyRequest(),
        this.setFileToExport,
      );
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    setFileToExport(response) {
      this.handleLoading();
      this.setFile(response);
    },
    setFile(response) {
      if (this.hasData(response)) {
        this.makePdfToDownload(response.data);
      }
    },
    makePdfToDownload(file) {
      this.createFile(
        [file],
        'application/pdf',
        'text/plain',
        `${this.$options.name}.pdf`,
      );
    },
  },
};
</script>
